/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';

import handleCharacterEncoding from '../../../handleCharacterEncoding';
import Kategorie from './img/kategorie.png';
import Genre from './img/einstellungen.png';
import Studiengang from './img/studiegang.png';
import Semester from './img/semester.png';
import {
  ID_INTERAKTIVE_MEDIEN,
  ID_INTERNET,
  ID_COMPUTERANIMATION,
  ID_FILM,
  ID_VISUAL_EFFECTS,
  ID_FERNSEHEN,
  ID_EVENT_MEDIA,
  ID_TON,
} from '../../../constants';
import './Details.css';

function Details({ daten, viewportWidth }) {
  // STATES

  const [studioTechnik, setStudioTechnik] = useState('');
  const [beschreibungstext, setBeschreibungstext] = useState('');
  const [semesterinwords, setSemesterinwords] = useState('');
  const [betreuerinwords, setBetreuerinwords] = useState('');
  const [numberofmembersinwords, setNumberofmembersinwords] = useState('');
  const [aufnahmetechnik, setAufnahmetechnik] = useState('');
  const [software, setSoftware] = useState('');
  const [programmierung, setProgrammierung] = useState('');
  const [sonstiges, setSonstiges] = useState('');
  const [technikenArr, setTechnikenArr] = useState('');
  const [studiengaengeSplit, setStudiengaengeSplit] = useState('');

  // FUNCTIONS
  /*
-----------------------------------------------
Trimmt Studiengang in ein einheitliches Format
-----------------------------------------------
*/
  function trimStudiegaenge(daten) {
    const split = daten[0].studiengaenge.split(',');
    let trimmed = '';

    for (let i = 0; i < split.length; i += 1) {
      if (split[i].match('Bachelor')) {
        trimmed += split[i];
      } else if (split[i].match('7 Semester')) {
        split[i] = ')';
        if (i === split.length - 1) {
          trimmed += split[i];
        } else {
          trimmed = `${trimmed + split[i]},`;
        }
      } else if (split[i].match('Zulassung')) {
        split[i] = ')';
        if (i === split.length - 1) {
          trimmed += split[i];
        } else {
          trimmed = `${trimmed + split[i]},`;
        }
      } else if (i === split.length - 1) {
        trimmed += split[i];
      } else {
        trimmed = `${trimmed + split[i]},`;
      }
    }
    setStudiengaengeSplit(trimmed);
  }

  /*
------------------------------------
Setzt Je nach id die Aufnahmetechnik
------------------------------------
  */
  // eslint-disable-next-line consistent-return
  function setUsedTechnology(daten) {
    setAufnahmetechnik(`${daten[0].aufnahmetechnik}`);

    let techniken = '';
    let technikentoreturn = '';

    if (aufnahmetechnik.localeCompare('') !== 0) {
      setAufnahmetechnik(`Aufnahmetechnik: ${aufnahmetechnik}`);
      techniken = `${aufnahmetechnik} & `;
    }

    setSoftware(`${daten[0].software}`);
    if (software.localeCompare('') !== 0) {
      setSoftware(`Software: ${software}`);
      techniken = `${techniken + software} & `;
    }

    setProgrammierung(`${daten[0].programmierung}`);
    if (programmierung.localeCompare('') !== 0) {
      setProgrammierung(`Programmierung: ${programmierung}`);
      techniken = `${techniken + programmierung} & `;
    }

    setSonstiges(`${daten[0].sonstiges}`);
    if (sonstiges.localeCompare('') !== 0) {
      setSonstiges(`Sonstiges: ${sonstiges}`);
      techniken += sonstiges;
    }

    setTechnikenArr(techniken.split(' & '));
    let arraysnotempty = false;
    for (let i = 0; i < technikenArr.length; i += 1) {
      if (technikenArr[i].localeCompare('') !== 0) {
        technikentoreturn = `${technikentoreturn + technikenArr[i]}\n`;
        arraysnotempty = true;
      }
    }

    if (arraysnotempty) {
      return (
        <div className="genre">
          <img
            style={{ minWidth: '30px', minHeight: '30px' }}
            src={Genre}
            width="30"
            height="30"
            alt="Genre Logo"
          />
          <p>{technikentoreturn}</p>
        </div>
      );
    }
  }

  /*
------------------------------------------------
Lange Version von medianight_semester erstellen
------------------------------------------------
*/
  function semesterText(daten) {
    const toTest = `${daten[0].medianight_semester}`;

    const sommer = toTest.match('SS');
    const winter = toTest.match('WS');

    if (sommer == null) {
      const wszahl = toTest.match('[0-9][0-9][0-9][0-9]/[0-9][0-9][0-9][0-9]');
      setSemesterinwords(`Wintersemester ${wszahl}`);
    } else if (winter == null) {
      const sszahl = toTest.match('[0-9][0-9][0-9][0-9]');
      setSemesterinwords(`Sommersemester ${sszahl}`);
    }
  }

  /*
-------------------------------
Anzahl Teammitglieder ermitteln
-------------------------------
*/
  function getNumberOfMemebers(daten) {
    const stuproTeam = `${daten[0].team}`;
    const members = stuproTeam.split(',');

    if (members.length === 1) {
      setNumberofmembersinwords(`${daten[0].team}`);
    } else {
      setNumberofmembersinwords(`einem ${members.length}-köpfigen Team`);
    }
  }

  /*
--------------------------------------------------------------------------
Betreuer stylen, "und" zwischen vorletztem und letztem Betreuer hinzufügen
--------------------------------------------------------------------------
*/
  function styleBetreuer(daten) {
    const stuproBetreuer = `${daten[0].betreuer}`;
    const betreuer = stuproBetreuer.split(',');

    for (let i = 0; i < betreuer.length; i += 1) {
      if (i === 0) {
        setBetreuerinwords(betreuer[i]);
      } else if (i > 0 && i < betreuer.length - 1) {
        setBetreuerinwords(`${betreuerinwords},${betreuer[i]}`);
      } else if (i === betreuer.length - 1) {
        setBetreuerinwords(`${betreuerinwords} und${betreuer[i]}`);
      }
    }
  }

  /*
----------------------------------
Setzt je nach id die Studiotechnik
----------------------------------
*/
  function defineStuPro(daten) {
    if (daten[0].am_studiotechnik_ID === ID_INTERAKTIVE_MEDIEN) {
      setStudioTechnik('Interaktive Medien');
    } else if (daten[0].am_studiotechnik_ID === ID_INTERNET) {
      setStudioTechnik('Internet');
    } else if (
      daten[0].am_studiotechnik_ID === ID_COMPUTERANIMATION
      && daten[0].projekt_medienart_ID === '16'
    ) {
      setStudioTechnik('Computeranimation');
    } else if (
      daten[0].am_studiotechnik_ID === ID_COMPUTERANIMATION
      && daten[0].projekt_medienart_ID !== '16'
    ) {
      setStudioTechnik('Sonstiges');
    } else if (daten[0].am_studiotechnik_ID === ID_FILM) {
      setStudioTechnik('Film');
    } else if (daten[0].am_studiotechnik_ID === ID_VISUAL_EFFECTS) {
      setStudioTechnik('Visual Effects');
    } else if (daten[0].am_studiotechnik_ID === ID_FERNSEHEN) {
      setStudioTechnik('Fernsehen');
    } else if (daten[0].am_studiotechnik_ID === ID_EVENT_MEDIA) {
      setStudioTechnik('Event Media');
    } else if (daten[0].am_studiotechnik_ID === ID_TON) {
      setStudioTechnik('Ton');
    } else {
      setStudioTechnik('Sonstiges');
    }
  }

  /*
----------------------------------------------------------------
Erstellt Default Text für Projekte, die keine Beschreibung haben
----------------------------------------------------------------
  */
  function createSimpleText(daten) {
    const regtestLetter = new RegExp('[a-z]');
    const regtestSpace = new RegExp(' ');

    // Test, ob Projekt eine Beschreibung hat
    if (
      regtestLetter.test(daten[0].beschreibung) === true
      && regtestSpace.test(daten[0].beschreibung) === true
    ) {
      /* Im Nachhinein ist mir aufgefallen, wie unnötig es ist, zwei Regex zu überprüfen,
  statt einen mit 2 Zeichen. Egal */
      setBeschreibungstext(daten[0].beschreibung);
    } else if (
      regtestLetter.test(daten[0].untertitel) === true
      && regtestSpace.test(daten[0].untertitel) === true
    ) {
      setBeschreibungstext(daten[0].untertitel);
    } else {
      defineStuPro(daten);
      getNumberOfMemebers(daten);
      semesterText(daten);
      styleBetreuer(daten);
      setBeschreibungstext(`"${daten[0].projekt_titel}" ist ein Projekt, das im Rahmen der 
        Studioproduktion ${studioTechnik} von ${numberofmembersinwords}
        unter der Betreuung von ${betreuerinwords} im ${semesterinwords} durchgeführt wurde.`);
    }
  }

  // EFFECTS
  useEffect(() => {
    createSimpleText(daten);
    defineStuPro(daten);
    trimStudiegaenge(daten);
    setUsedTechnology(daten);
  }, [daten]);

  /* Die Property viewportWidth reicht die aktuelle ClientViewport Breite von der
  Videoprojektpage weiter */
  const viewPortClass = viewportWidth < 768 ? 'details-mobil' : 'details';
  let detailsHeight = '';
  if (viewportWidth > 768) {
    detailsHeight = daten[0].aufnahmetechnik.length > 0
      ? '350px'
      : '250px';
  } else if (viewportWidth < 769) {
    detailsHeight = '';
  }
  // Variablen für Metadaten siehe unten in Return () - für Whatsapp Übergabe gedacht
  const nameProject = `${daten[0].projekt_titel}`;
  const linkProject = `https://hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}/details}`;
  const descriptionProject = `${daten[0].untertitel}`;
  const bildProject = `https://hdm-stuttgart.de/mediathek/stage_mediafiles/${daten[0].projekt_ID}/medianight_web/klein.jpg`;

  // RENDER
  return (
    <div className={viewPortClass} style={{ height: detailsHeight }}>
      <MetaTags>
        <meta property="og:title" content={nameProject} />
        <meta property="og:url" content={linkProject} />
        <meta property="og:description" content={descriptionProject} />
        <meta property="og:image" content={bildProject} />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content="de_DE" />
      </MetaTags>
      <div
        className={viewportWidth < 768 ? 'details_left-mobil' : 'details_left'}
        id="details_left_id"
      >
        <p>{handleCharacterEncoding(beschreibungstext)}</p>
      </div>
      <div
        className={
          viewportWidth < 768 ? 'details_right-mobil' : 'details_right'
        }
      >
        <div className="kategorie">
          <img
            style={{ minWidth: '28px', minHeight: '28px' }}
            src={Kategorie}
            width="28"
            height="28"
            alt="Kategorie Logo"
          />
          <p>{studioTechnik}</p>
        </div>

        <div className="studiengang">
          <img
            style={{ minWidth: '30px', minHeight: '30px' }}
            src={Studiengang}
            width="33"
            height="33"
            alt="Studiengang Logo"
          />

          <p>{studiengaengeSplit}</p>
        </div>

        <div className="semester">
          <img
            style={{ minWidth: '30px', minHeight: '30px' }}
            src={Semester}
            width="30"
            height="30"
            alt="Semester Logo"
          />
          <p>{daten[0].medianight_semester}</p>
        </div>

        <div className="genre" />
      </div>
    </div>
  );
}

export default Details;

Details.propTypes = {
  viewportWidth: PropTypes.number.isRequired,
};
